import { TextTemplate, Option } from "../../common/models/flow.dto";


export interface Reminder{
    id:string;
    active: boolean;
    deliveryMethods: ReminderDeliveryMethod;
    documentTypeId: string;
    getEverythingWithinTheTimeframe: boolean;
    internalGroupsToNotifyIds: string[];
    name: string;
    timeframe: number;
    timeframeIsInBusinessDays: boolean;
    reportTemplateId: string;
    type: ReminderType
}

export enum ReminderDeliveryMethod
{
    None = 0,
    Email = 1,
    RegularMail = 2,
    CertifiedMail = 4,
    Notification = 8,
}

export class ReminderDeliveryMethodOptions {
  public static None: Option = { id: ReminderDeliveryMethod.None.toString(), text: "None" };
  public static Email: Option = { id: ReminderDeliveryMethod.Email.toString(), text: "Email" };
  public static RegularMail: Option = { id: ReminderDeliveryMethod.RegularMail.toString(), text: "Regular Mail" };
  public static CertifiedMail: Option = { id: ReminderDeliveryMethod.CertifiedMail.toString(), text: "Certified Mail" };
  public static Notification: Option = { id: ReminderDeliveryMethod.Notification.toString(), text: "Notification" };
  public static All: Option[] = [
    //ReminderDeliveryMethodOptions.None,
    ReminderDeliveryMethodOptions.Email,
    ReminderDeliveryMethodOptions.RegularMail,
    ReminderDeliveryMethodOptions.CertifiedMail,
    ReminderDeliveryMethodOptions.Notification
  ];
}

export enum ReminderType {
    InsuranceExpiration = 0,
    BondingCertificateOfDepositMaturation = 1,
    BondingFinancialStatementExpiration = 2,
    BondingLetterOfCreditExpiration = 3,
    BondingSuretyBondExpiration = 4,
    BondingOutOfCompliance = 5,
    InsuranceOutOfCompliance = 6,
}

export class ReminderTypeOptions {
  public static InsuranceExpiration: Option = { id: ReminderType.InsuranceExpiration.toString(), text: "Insurance Expiration" };
  public static BondingCertificateOfDepositMaturation: Option = { id: ReminderType.BondingCertificateOfDepositMaturation.toString(), text: "Bonding Certificate of Deposit Maturation" };
  public static BondingFinancialStatementExpiration: Option = { id: ReminderType.BondingFinancialStatementExpiration.toString(), text: "Bonding Financial Statement Expiration" };
  public static BondingLetterOfCreditExpiration: Option = { id: ReminderType.BondingLetterOfCreditExpiration.toString(), text: "Bonding Letter of Credit Expiration" };
  public static BondingSuretyBondExpiration: Option = { id: ReminderType.BondingSuretyBondExpiration.toString(), text: "Bonding Surety Bond Expiration" };
  public static BondingOutOfCompliance: Option = { id: ReminderType.BondingOutOfCompliance.toString(), text: "Bonding Out of Compliance" };
  public static InsuranceOutOfCompliance: Option = { id: ReminderType.InsuranceOutOfCompliance.toString(), text: "Insurance Out of Compliance" };
  public static All: Option[] = [
    ReminderTypeOptions.InsuranceExpiration,
    ReminderTypeOptions.BondingCertificateOfDepositMaturation,
    ReminderTypeOptions.BondingFinancialStatementExpiration,
    ReminderTypeOptions.BondingLetterOfCreditExpiration,
    ReminderTypeOptions.BondingSuretyBondExpiration,
    ReminderTypeOptions.BondingOutOfCompliance,
    ReminderTypeOptions.InsuranceOutOfCompliance
  ];
}